import React from 'react';
import Row, { RowBetween } from 'components/Row';
import { TYPE } from 'theme';
import styled from 'styled-components';
import { AutoColumn } from 'components/Column';
import { StyledButton, StyledMissionCard } from './styled';
import { observer } from 'mobx-react';
import { isMobile } from 'react-device-detect';
import { TaskConfig } from '.';
import { AksharFont } from 'theme/commonStyles';

const Description = styled.div`
    min-height: 60px;
    margin: 10px 0;
    flex: 1;
`;

const PointsText = styled.div`
    ${AksharFont}
    font-size: 32px;
    font-weight: 700;
    color: #5fd15c;
`;

const MissionChain = ({ task }: { task: TaskConfig }) => {
    const { description, title, points, link, icon, subTitle } = task;

    const onClick = async () => {
        window.open(link, '_blank');
    };

    return (
        <StyledMissionCard>
            <Row direction="column" height="100%" align="start" gap="10px">
                <RowBetween wrap={isMobile ? 'wrap' : undefined} style={{ alignItems: 'start' }}>
                    <AutoColumn gap="4px">
                        <Row gap="10px" width="auto">
                            {icon}
                            <div>
                                <TYPE.main fontWeight={700}>{title}</TYPE.main>
                            </div>
                        </Row>
                        {subTitle ? (
                            <TYPE.desc fontSize="12px" color="rgba(153, 153, 153, 1)">
                                {subTitle}
                            </TYPE.desc>
                        ) : null}
                    </AutoColumn>
                    {points ? (
                        <AutoColumn justify="center">
                            <PointsText>+ {points}</PointsText>
                            <TYPE.desc fontSize="12px" color="#fff">
                                {task.title === 'Avalon' || task.title === 'Stable Jack'
                                    ? 'Points/day(1USDT)'
                                    : task.title === 'Scoremilk'
                                    ? 'Points/play'
                                    : 'Points'}
                            </TYPE.desc>
                        </AutoColumn>
                    ) : null}
                </RowBetween>
                <Description>
                    <TYPE.desc style={{ whiteSpace: 'pre-line' }}>{description}</TYPE.desc>
                </Description>
                <StyledButton type="outlineGradient" size="unset" onClick={onClick}>
                    Go to {title}
                </StyledButton>
            </Row>
        </StyledMissionCard>
    );
};

export default observer(MissionChain);
